<template>
  <p
      :class="errorContextProps ? '' : 'visibility_hidden'"
      class="txt_info txt_red"
      style="height: 15px;"
  >
    {{ errorContextProps }}
  </p>
</template>
<script>
  export default {
    name: 'LoginErrorContext',
    props:{
      errorContextProps: String
    }
  }
</script>